import { FC } from "react";
import GivenchyCheckBoxDefault from "../../../../icons/GivenchyCheckboxes/GivenchyCheckBoxDefault";
import GivenchyCheckBoxChecked from "../../../../icons/GivenchyCheckboxes/GivenchyCheckBoxChecked";

import "./index.css";

interface IPropsGivenchyCheckbox extends React.InputHTMLAttributes<HTMLInputElement> {
  checked: boolean;
  sx?: React.CSSProperties;
}

const GivenchyCheckbox: FC<IPropsGivenchyCheckbox> = ({
  checked,
  onChange,
  sx,
  id = "givenchy-checkbox",
  ...inputProps
}) => {
  const iconsStyles = {
    fontSize: "15px",
    height: "15px",
  };

  return (
    <label htmlFor={id} className="givenchy-checkbox" style={sx}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="givenchy-checkbox__input"
        {...inputProps}
      />

      {checked ? (
        <GivenchyCheckBoxChecked sx={iconsStyles} aria-hidden="true" />
      ) : (
        <GivenchyCheckBoxDefault sx={iconsStyles} aria-hidden="true" />
      )}
    </label>
  );
};

export default GivenchyCheckbox;
